module.exports = __webpack_public_path__ + "0ede7516b5e2737b77e1d5ddee88996f.pdf";